/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Vibebids_Minutes_AgoInputs */

const en_directory_vibebids_minutes_ago = /** @type {(inputs: Directory_Vibebids_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} minutes ago`)
};

const zh_directory_vibebids_minutes_ago = /** @type {(inputs: Directory_Vibebids_Minutes_AgoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} 分钟前`)
};

/**
* | output |
* | --- |
* | "{count} minutes ago" |
*
* @param {Directory_Vibebids_Minutes_AgoInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_vibebids_minutes_ago = /** @type {((inputs: Directory_Vibebids_Minutes_AgoInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Vibebids_Minutes_AgoInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_vibebids_minutes_ago(inputs)
	return zh_directory_vibebids_minutes_ago(inputs)
});
export { directory_vibebids_minutes_ago as "directory.vibebids.minutes_ago" }